<template>
    <div>
        <navView @handleCommand="handleCommand" />
        <VueOfficeDocx :src="pathDocx" style="height:100vh;padding-top:120px" />
        <!-- <footerView /> -->
    </div>
</template>
  
<script>
import navView from '@/components/nav.vue'
import footerView from '@/components/footer.vue'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
export default {
    name: 'MyComponent',
    components: {
        navView, VueOfficeDocx, footerView
    },
    data() {
        return {
            pathDocx: '',
            isLoading: true
        };
    },
    created() {
        console.log(this.$route.query)
        this.pathDocx = this.$route.query.url
        console.log(this.pathDocx)
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.pathDocx) {
            loading.close();
        }

    },
    methods: {
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
            } else {
                this.$i18n.locale = 'zh'
            }
        }
    }
};
</script>
  